import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { DestinyService } from '../../../services';
import { SeoService } from '../../../services/seo/seo.service';
import { StorageService } from '../../../services/storage';
import { AccountsService } from '../../../services/user-account/accounts.service';
import { StorageKeysEnum } from '../../../shared/constants';
import { HomeTab, TAB_CONFIG } from '../constants';
import { BannersFacade } from './banners.facade';
import { CmsFacade } from './cms.facade';
import { FlightOffersFacade } from './flight-offers.facade';
import { HomeState } from './home.state';

@Injectable()
export class HomeFacade {
  private readonly state = inject(HomeState);
  private readonly bannersFacade = inject(BannersFacade);
  private readonly cmsFacade = inject(CmsFacade);
  private readonly flightOffersFacade = inject(FlightOffersFacade);
  private readonly destinationService = inject(DestinyService);
  private readonly accountsService = inject(AccountsService);
  private readonly storageService = inject(StorageService);
  private readonly seoService = inject(SeoService);

  readonly selectedTabIndex = this.state.selectedTabIndex;
  readonly tabs = this.state.displayHomeTabs;

  initHome(): void {
    this.bannersFacade.fetchBanners();
    this.cmsFacade.fetchHomeSections();
    this.flightOffersFacade.fetchOffers();
    this.destinationService.setOrigin('LIM', 'Lima', 'Perú');
    this.storageService.removeItem(StorageKeysEnum.FILTERS);
  }

  updateTabByPath(url: string): void {
    const path = url.replace(/^\/+|\/+$/g, '').trim();
    this.seoService.updateSeoByPath(path);

    const config = Object.values(TAB_CONFIG).find((c) => c.path === path) ?? TAB_CONFIG[0];
    this.state.setSelectedTabIndex(config.index);
    this.seoService.updatePageMetaTags(config.seo);
  }

  getPathByTabIndex(index: HomeTab): string {
    return TAB_CONFIG[index]?.path || '/';
  }

  confirmEmailByUserId(id: string): Observable<boolean> {
    return this.accountsService.confirmUserEmail(id).pipe(
      tap((response) => {
        if (response.isSuccess) this.accountsService.dispatchConfirmate(true);
      }),
      map((response) => response.isSuccess),
      catchError(() => of(false)),
    );
  }
}
